export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-2xl font-semibold text-atlas-ink">Privacy</h1>
      <p className="mt-4 text-atlas-ink">
        Demo configurations submitted to the generator are stored only as needed to render the shareable demo map.
        Lead-capture submissions (name, email, organization, optional phone) are emailed to AtlasGeo and retained for follow-up.
        We do not sell or share lead information with third parties.
      </p>
    </div>
  );
}
